import React from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import CheckoutLayout from "@/components/CheckoutLayout";
import { ArrowLeft, LayoutDashboard } from "lucide-react";

export default function CheckoutCancel() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const tier = params.get("tier") || "";

  return (
    <CheckoutLayout>
      <div className="vbs-upsell-hero">
        <div className="ok" style={{ color: "#c9a84c" }}>Checkout Cancelled</div>
        <h1>No charge. <em>No hard feelings.</em></h1>
        <p>
          You left without completing your payment{tier ? ` for ${tier.replace("_", " ")}` : ""}.
          The offer is still there whenever you're ready.
        </p>
        <div style={{ marginTop: 28, display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
          <button onClick={() => nav("/#pricing")} className="mkt-btn mkt-btn-primary" data-testid="cancel-back">
            <ArrowLeft size={14} /> Back to Pricing
          </button>
          <button onClick={() => nav("/dashboard")} className="mkt-btn mkt-btn-ghost" data-testid="cancel-dashboard">
            <LayoutDashboard size={14} /> Open Dashboard
          </button>
        </div>
      </div>
    </CheckoutLayout>
  );
}
